'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactMeasure = require('react-measure');

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Provides an onResize callback that gets fired when the child element gets resized
 */
var ResizeMonitor = function (_Component) {
  _inherits(ResizeMonitor, _Component);

  function ResizeMonitor(props, context) {
    _classCallCheck(this, ResizeMonitor);

    var _this = _possibleConstructorReturn(this, (ResizeMonitor.__proto__ || Object.getPrototypeOf(ResizeMonitor)).call(this, props, context));

    _this.onResizeInternal = function () {
      var currentTimestamp = Date.now();
      if (currentTimestamp > _this.state.timestampOfLastResizeEvent + 100) {
        _this.setState({
          timestampOfLastResizeEvent: currentTimestamp
        });

        _this.props.onResize();
      }
    };

    _this.state = {
      timestampOfLastResizeEvent: Date.now()
    };
    return _this;
  }

  /**
   * Throttles incoming resize events if they are very close together
   */


  _createClass(ResizeMonitor, [{
    key: 'render',


    /**
     * Rather than putting the Measure component around our element to watch, we create a second (empty) div
     * that is a sibling of the child elements and measure that.
     *
     * Because we have to pass measureRef to the child elements, the to-measure element has to be contained
     * inside the lambda function. However because the lambda function cannot render,
     * we can only contain already-rendered elements inside it (i.e. hardcoded html).
     * To fix this status quo, we combine both siblings in a parent div that has the full width available.
     * The mock div will be invisible and, just like the actual child elements, stretch to full size.
     * We can then trigger the callback on the child elements whenever the mock div resizes.
     */
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { width: '100%' } },
        _react2.default.createElement(
          _reactMeasure2.default,
          { bounds: true, onResize: this.onResizeInternal },
          function (_ref) {
            var measureRef = _ref.measureRef;
            return _react2.default.createElement('div', { ref: measureRef });
          }
        ),
        this.props.children
      );
    }
  }]);

  return ResizeMonitor;
}(_react.Component);

ResizeMonitor.propTypes = {
  children: _propTypes2.default.node.isRequired,
  onResize: _propTypes2.default.func
};
exports.default = ResizeMonitor;
module.exports = exports['default'];